import { holeCardsParser } from '../../../types/cardTypes';
import { booleanParser, numberOrUndefinedParser, numberParser } from '../inboundParsers';
export const HAND_RECONNECT_PAYLOAD_DEFINITION = {
    shouldSplitWithBraces: true,
    definitionParts: [
        { name: 'currentNumHoleCards', parser: numberParser },
        { name: 'holeCards', parser: holeCardsParser },
        { name: 'minimumBet', parser: numberParser },
        { name: 'maximumBet', parser: numberParser },
        { name: 'betIncrement', parser: numberParser },
        { name: 'isDiscardPhase', parser: booleanParser },
        { name: 'discardedCardIndex', parser: numberOrUndefinedParser }
    ]
};
